export class ebGroupe {
  ebGroupeNum: number;
  nom: string;

  constructor() {
    this.ebGroupeNum = null;
    this.nom = null;
  }

  constructorCopy(ebGoupe:ebGroupe){
    this.constructor();
    this.ebGroupeNum = ebGoupe.ebGroupeNum;
    this.nom = ebGoupe.nom;

  }
}



// WEBPACK FOOTER //
// ./src/app/classes/groupe.ts